import { Place, CurrentAddressData } from '@/src/interfaces'

export const getFormattedAddressData = (place: Place): CurrentAddressData => {
  const street = place.text || ''
  const context = place.context || []

  const city = context.find((item) => item.id.includes('place'))?.text || ''
  const stateInfo = context.find((item) => item.id.includes('region'))
  const state = stateInfo ? (stateInfo.short_code || '').split('-')[1] : ''
  const zip = context.find((item) => item.id.includes('postcode'))?.text || ''
  const country =
    context.find((item) => item.id.includes('country'))?.text || ''

  const components = [street, city, state, zip, country].filter(
    (component) => component
  )
  const fullAddress = components.join(', ')
  return { city, state, zip, fullAddress }
}
